import React from "react";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { UnitTableCategoryFilter } from "@/components/controls/filter/UnitTableCategoryFilter";
import { UnitTableFeatureFilter } from "@/components/controls/filter/UnitTableFeatureFilter";
import { Button } from "@/components/ui/button";
import type { UnitFeature, UnitCategory } from "@/types";

interface UnitTableFiltersProps {
    features: UnitFeature[];
    selectedFeatures: number[];
    setSelectedFeatures: React.Dispatch<React.SetStateAction<number[]>>;
    categories: UnitCategory[];
    selectedCategories: number[];
    setSelectedCategories: React.Dispatch<React.SetStateAction<number[]>>;
}

export const UnitTableFilters = ({
    features,
    selectedFeatures,
    setSelectedFeatures,
    categories,
    selectedCategories,
    setSelectedCategories,
}: UnitTableFiltersProps) => {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button variant={"outline"}>Filters</Button>
            </PopoverTrigger>
            <PopoverContent className="se-vapor se-vapor-filters">
                <UnitTableFeatureFilter
                    features={features}
                    selectedFeatures={selectedFeatures}
                    setSelectedFeatures={setSelectedFeatures}
                />
                <UnitTableCategoryFilter
                    categories={categories}
                    selectedCategories={selectedCategories}
                    setSelectedCategories={setSelectedCategories}
                />
            </PopoverContent>
        </Popover>
    );
};
